export const TrimPricePlanSource = {
    autoAlertPrice: 0,
    dealerPrice: 1,
    aZPlan: 2,
    xPlan: 3,
    employeePricing: 4
}

export default TrimPricePlanSource;